import React, { useEffect, useState } from "react";
import Header from "../component/layout/header";
import FooterSection from "../component/layout/footer";

function TermsAndCondition() {
  return (
    <div>
      <Header />
      <div className="contact-section">
        <div
          className="contact-top padding-tb aside-bg"
          style={{
            "margin-left": "20px",
            "margin-right": "20px",
            "padding-top": "200px",
          }}
        >
          <div className="vc_row wpb_row vc_row-fluid vc_custom_1497013187222">
            <div className="row-container vc_row-flex row-default vc_row">
              <div className="wpb_column vc_column_container vc_col-sm-12">
                <div className="vc_column-inner ">
                  <div className="wpb_wrapper policy-wrapper">
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <h2>Terms & Conditions</h2>
                      </div>
                    </div>

                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p className="p1">
                          <span className="s1">
                          Welcome to Tegal app referred to as (the “Company”, “Tegal app”, “Tegal” or “Us” “Service”).
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            By creating a Tegal account or by using our service
                            (collectively, the “Service”) you agree to be bound
                            by these Terms of Use and our Privacy Policy, which
                            is incorporated by reference into this Agreement and
                            available through our Service (this “Agreement”). If
                            you do not accept and agree to be bound by all of
                            the terms of this Agreement, please do not use the
                            Service.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            <b>1) Acceptance of Terms of Use Agreement</b>
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            a) &nbsp;This Agreement is an electronic contract
                            that establishes the legally binding terms you must
                            accept to use Tegal. This Agreement includes the
                            Company’s Privacy Policy and terms disclosed and
                            agreed to by you if you use or accept additional
                            features, or services we offer on Tegal.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            b) &nbsp;We may, at any time and for any reason make
                            changes to this Agreement. We may do this for a
                            variety of reasons including to reflect changes in
                            or requirements of the law, new features, or changes
                            in business practices. The most recent version of
                            this Agreement will be posted on Tegals under
                            Settings and also on{" "}
                            <a href="https://tegalapp.com">
                              https://tegalapp.com
                            </a>{" "}
                            and you should regularly check for the most recent
                            version. The most recent version is the version that
                            applies. If the changes include material changes
                            that affect your rights or obligations, we will
                            notify you of the changes by reasonable means, which
                            could include notification through Tegal's or via
                            email. If you continue to use Tegal after the
                            changes become effective, then you shall be deemed
                            to have accepted those changes. If you don’t agree
                            to these changes, you must end your relationship
                            with us by ceasing to use Tegal and terminating your
                            profile and subscription with Tegal app.
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            <b>2) Eligibility</b>
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            You must be at least 18 years of age to create an
                            account on Tegal and use Tegal. By creating an
                            account and using Tegal, you represent and warrant
                            that you can form a binding contract with Tegal, you
                            are not a person who is barred from using Tegal
                            under the laws of your country or any other
                            applicable jurisdiction–or face any other similar
                            prohibition, and you will comply with this Agreement
                            and all applicable laws and regulations.
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <b>3</b>
                          <span className="s1">
                            <b>) Creating an Account on Tegal</b>
                            <br />
                            In order to use Tegal, you must have or create a
                            Google gmail account and sign in using your Google
                            auth or by providing email and password. If you do
                            so, you authorise us to access and use certain
                            Google account information, including your display
                            name, email. For more information regarding the
                            information we collect from you and how we use it,
                            please consult our Privacy Policy.
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <b>4</b>
                          <span className="s1">
                            <b>) Terms for Tegal app</b>
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            a) &nbsp;Our service allows users to meet other
                            users using personal information provided on the
                            app, and time frame preferences. Our app connect men
                            and women for a geniune relationship that lead to
                            marriage. In providing details in your ‘set up
                            profile’ such as, photo, genotype, blood group, life
                            style information, occupation, description, you
                            hereby declare all information is truthful. In the
                            event that it is determined that any of the
                            information you have provided is misleading or
                            inaccurate, we reserve the right to terminate your
                            account and enrase the data.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            b) &nbsp;Tegal app was established as a platform for
                            people who are serious about meeting other people
                            for mariage purpose, and we do not support
                            untrustworthy or fickle behaviour. As such, if you
                            cancel or fail to turn up to a date on two or more
                            occasions, your account will be partially blocked
                            for a 24h period and no further dates can be
                            arranged during this time. By using these Services,
                            you understand and agree that ongoing offences could
                            result in permanent baring of your Tegal account by
                            the Company in its sole discretion. Upon such
                            termination or suspension, you will not be entitled
                            to any pro-rata refund of unused app purchases.
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <b>5</b>
                          <span className="s1">
                            <b>) Non-commercial Use by Users</b>
                            <br />
                            Tegal is for personal use only. Users may not use
                            Tegal or any content contained in the Service
                            (including, but not limited to, content of other
                            users, designs, text, graphics, images, video,
                            logos, software, and computer code) in connection
                            with any commercial endeavours, such as advertising
                            or soliciting any user to buy or sell any products
                            or services not offered by the Company. Users of the
                            Service may not use any information obtained from
                            Tegal to contact, advertise to, solicit, or sell to
                            any other user without his or her prior explicit
                            consent. Organisations, companies, and/or businesses
                            may not use Tegal for any purpose except with
                            Tegal’s express consent (such as for promoted
                            profiles or other advertisements), which Tegal may
                            provide or deny in its sole discretion. The Company
                            may investigate and take any available legal action
                            in response to illegal and/or unauthorised uses of
                            Tegal.
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <b>6</b>
                          <span className="s1">
                            <b>) Account Security</b>
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            a) You are responsible for maintaining the
                            confidentiality of your Tegal login credentials that
                            you use to sign up for Tegal, and you are solely
                            responsible for all activities that occur under
                            those credentials.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            b) You agree to immediately notify the Company of
                            any disclosure or unauthorised use of your login
                            credentials at
                          </span>
                          <span className="s2">hello@tegalapp.com </span>
                          <span className="s1">
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <b>7</b>
                          <span className="s1">
                            <b>
                              ) Your Interactions, and personal safety with
                              Other Users
                            </b>
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            a) You are solely responsible for your interactions
                            with other users. You understand that the company
                            currently does not conduct criminal background
                            checks on its users. The company also does not
                            verify the statements of its users. The company
                            makes no representations or warranties as to the
                            conduct of users or their compatibility with any
                            current or future users. The company reserves the
                            right to conduct any criminal background check or
                            other screenings (such as sex offender register
                            searches), at any time and using available public
                            records to the extent permitted by law.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            b) The Company is not responsible for the conduct of
                            any user. As noted in and without limiting Sections
                            16 and 18 below, in no event shall the Company, its
                            affiliates or its partners be liable (directly or
                            indirectly) for any losses or damages whatsoever,
                            whether direct, indirect, general, special,
                            compensatory, consequential, and/or incidental,
                            arising out of or relating to the conduct of you or
                            anyone else in connection with the use of the
                            Service including, without limitation, death, bodily
                            injury, emotional distress, and/or any other damages
                            resulting from communications or meetings with other
                            users or persons you meet through Tegal. You agree
                            to take all necessary precautions in all
                            interactions with other users, particularly if you
                            decide to communicate off Tegal.
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <b>8</b>
                          <span className="s1">
                            <b>) Content Posted by You in Tegal </b>
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            a) You are solely responsible for the content and
                            information that you post, upload, publish, link to,
                            transmit, record, display or otherwise make
                            available (collectively, “post”) on Tegal or
                            transmit to other users. You may not post as part of
                            Tegal, or transmit to the Company or any other user
                            (either on or off Tegal), any offensive, inaccurate,
                            incomplete, abusive, obscene, profane, threatening,
                            intimidating, harassing, racially offensive, or
                            illegal material, or any material that infringes or
                            violates another person’s rights (including
                            intellectual property rights, and rights of privacy
                            and publicity). You represent and warrant that;
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            (i) all information that you submit upon creation of
                            your account, including information submitted from
                            your Facebook account, is accurate and truthful and
                            that you will promptly update any information
                            provided by you that subsequently becomes
                            inaccurate, incomplete, misleading or false
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            (ii) you have the right to post the Content on the
                            Service and grant the licenses set forth below.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            b) You understand and agree that the Company may,
                            but is not obligated to, monitor or review any
                            Content you post as part of a Service. The Company
                            may delete any Content, in whole or in part, that in
                            the sole judgment of the Company violates this
                            Agreement or may harm the reputation of Tegal or the
                            Company.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            c) By posting Content as part of Tegal, you grant to
                            Tegal a worldwide, transferable, sub-licensable,
                            royalty-free, right and license to host, store, use,
                            copy, display, reproduce, adapt, edit, publish,
                            modify and distribute the Content. This license is
                            for the limited purpose of operating, developing,
                            providing, promoting, and improving Tegal and
                            researching and developing new ones.
                          </span>
                        </p>
                        <p className="p1">
                          d)
                          <span className="s1">
                            &nbsp;In addition to the types of Content described
                            in Section 9)a) above, the following is a partial
                            list of the kind of Content that is prohibited in
                            Tegal. You may not post, upload, display or
                            otherwise make available Content that promotes
                            racism, bigotry, hatred or physical harm of any kind
                            against any group or individual; advocates
                            harassment or intimidation of another person;
                            requests money from, or is intended to defraud,
                            other users of Tegal; spams or solicits Tegal’s
                            users; promotes information that is false or
                            misleading, or promotes illegal activities or
                            conduct that is defamatory, libellous or otherwise
                            objectionable; promotes an illegal or unauthorised
                            copy of another person’s copyrighted work, such as
                            providing pirated computer programs, images, audio
                            or video files or links to them; contains video,
                            audio photographs, or images of another person
                            without his or her permission (or in the case of a
                            minor, the minor’s legal guardian); contains
                            restricted or password only access pages, or hidden
                            pages or images (those not linked to or from another
                            accessible page); provides material that exploits
                            people in a sexual, violent or other illegal manner,
                            or solicits personal information from anyone under
                            the age of 18; provides nstructional information
                            about illegal activities such as making or buying
                            illegal weapons or drugs, violating someone’s
                            privacy, or providing, disseminating or creating
                            computer viruses; contains viruses, time bombs,
                            trojan horses, cancelbots, worms or other harmful,
                            or disruptive codes, components or devices;
                            impersonates, or otherwise misrepresents
                            affiliation, connection or association with, any
                            person or entity; provides information or data you
                            do not have a right to make available under law or
                            under contractual or fiduciary relationships (such
                            as inside information, proprietary and confidential
                            information); solicits passwords or personal
                            identifying information for commercial or unlawful
                            purposes from other users or disseminates another
                            person’s personal information without his or her
                            permission.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            e) The Company reserves the right, in its sole
                            discretion, to investigate and take any legal action
                            against anyone who violates this provision,
                            including removing the offending communication from
                            Tegal and terminating or suspending the account of
                            such violators.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            f) Your use of Tegal, including all Content you post
                            through Tegal, must comply with all applicable laws
                            and regulations. You agree that the Company may
                            access, preserve and disclose your account
                            information and Content if required to do so by law
                            or in a good faith belief that such access,
                            preservation or disclosure is reasonably necessary,
                            such as to:
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            i) &nbsp;comply with legal process;
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            ii) &nbsp;enforce this Agreement;
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            iii) &nbsp;respond to claims that any Content
                            violates the rights of third parties;
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            <br />
                            iv) &nbsp;respond to your requests for customer
                            service or allow you to use Tegal in the future;
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            v) &nbsp;protect the rights, property or personal
                            safety of the Company or any other person.
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            g) You agree that any Content you place on the
                            Service may be viewed by other users and may be
                            viewed by any person visiting or participating in
                            Tegal.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            <b>9) Prohibited Activities</b>
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            The Company reserves the right to investigate,
                            suspend and/or terminate your account if you have
                            misused Tegal or behaved in a way the Company
                            regards as inappropriate or unlawful, including
                            actions or communications the occur off Tegal but
                            involve users you meet through Tegal. The following
                            is a partial list of the type of actions that you
                            may not engage in with respect to the Service. You
                            will not;
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            a) &nbsp;impersonate any person or entity.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            b) &nbsp;solicit money from any users.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            c) &nbsp;post any Content that is prohibited by
                            Section 8.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            d) &nbsp;“stalk” or otherwise harass any person.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            e) &nbsp;express or imply that any statements you
                            make are endorsed by the Company without our
                            specific prior written consent.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            f) &nbsp;use Tegal in an illegal manner or to commit
                            an illegal act.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            g) &nbsp;access Tegal in a jurisdiction in which it
                            is illegal or unauthorised;
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            h) &nbsp;use any robot, spider, site
                            search/retrieval application, or other manual or
                            automatic device or process to retrieve, index,
                            “data mine”, or in any way reproduce or circumvent
                            the navigational structure or presentation of the
                            Service or its contents.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            i) &nbsp;collect usernames and/or email addresses of
                            users by electronic or other means for the purpose
                            of sending unsolicited email or unauthorised framing
                            of or linking to Tegal.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            j) &nbsp;interfere with or disrupt Tegal or the
                            servers or networks connected to Tegal.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            k) &nbsp;transmit any material that contains
                            software viruses or any other computer code, files
                            or programs designed to interrupt, destroy or limit
                            the functionality of any computer software or
                            hardware or telecommunications equipment.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            l) &nbsp;forge headers or otherwise manipulate
                            identifiers in order to disguise the origin of any
                            information transmitted to or through Tegal (either
                            directly or indirectly through use of third party
                            software).
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            m) &nbsp;“frame” or “mirror” any part of the
                            Service, without the Company’s prior written
                            authorisation.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            n) &nbsp;use meta tags or code or other devices
                            containing any reference to the Company or the
                            Service (or any trademark, trade name, service mark,
                            logo or slogan of the Company) to direct any person
                            to any other website for any purpose.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            o) &nbsp;modify, adapt, sublicense, translate, sell,
                            reverse engineer, decipher, decompile or otherwise
                            disassemble any portion of Tegal any software used
                            on or for Tegal, or cause others to do so.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            p) &nbsp;post, use, transmit or distribute, directly
                            or indirectly, (e.g. screen scrape) in any manner or
                            media any content or information obtained from the
                            Service other than solely in connection with your
                            use of Tegal in accordance with this Agreement.
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            <b>10) Customer Service</b>
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            The Company provides assistance and guidance through
                            its customer care representatives. When
                            communicating with our customer care
                            representatives, you agree to be respectful and
                            kind. If we feel that your behaviour towards any of
                            our customer care representatives or other employees
                            is at any time threatening or offensive, we reserve
                            the right to immediately terminate your account with
                            no refund of any subscription or in app purchase
                            fees.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            <b>11) In App Purchases </b>
                            <br />
                            If you choose to make an in app purchase, you will
                            be prompted to enter details for your account with
                            the mobile platform you are using (e.g., Apple,
                            Android, etc.) (“your IAP Account”), and your IAP
                            Account will be charged for the in app purchase in
                            accordance with the terms disclosed to you at the
                            time of purchase as well as the general terms for in
                            app purchases that apply to your IAP Account.
                          </span>
                          <span className="s3">
                            You will not be charged re-occurring payments
                          </span>
                          <span className="s1">
                            . Please refer to the terms of your application
                            platform which apply to your in app purchases.
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            <b>12) Modifications to Service </b>
                            <br />
                            The Company reserves the right at any time to modify
                            or discontinue, temporarily or permanently, the
                            Service (or any part thereof) with or without
                            notice. You agree that the Company shall not be
                            liable to you or to any third party for any
                            modification, suspension or discontinuance of the
                            Service. To protect the integrity of Tegal, the
                            Company reserves the right at any time in its sole
                            discretion to block users from certain IP addresses
                            from accessing Tegal.
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <b>13</b>
                          <span className="s1">
                            <b>) Proprietary Rights </b>
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            The Company owns and retains all proprietary rights
                            in Tegal, and in all content, trademarks, trade
                            names, service marks and other intellectual property
                            rights related thereto. Tegal contains the
                            copyrighted material, trademarks, and other
                            proprietary information of the Company and its
                            licensors. You agree to not copy, modify, transmit,
                            create any derivative works from, make use of, or
                            reproduce in any way any copyrighted material,
                            trademarks, trade names, service marks, or other
                            intellectual property or proprietary information
                            accessible through Tegal, without first obtaining
                            the prior written consent of the Company or, if such
                            property is not owned by the Company, the owner of
                            such intellectual property or proprietary rights.
                            You agree to not remove, obscure or otherwise alter
                            any proprietary notices appearing on any content,
                            including copyright, trademark and other
                            intellectual property notices.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            <b>14) Copyright</b>
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            a) &nbsp;You may not post, distribute, or reproduce
                            in any way any copyrighted material, trademarks, or
                            other proprietary information without obtaining the
                            prior written consent of the owner of such
                            proprietary rights. If you believe that your work
                            has been copied and posted on Tegal in a way that
                            constitutes copyright infringement, please provide
                            Tegal app with the following information:
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            i) &nbsp;an electronic or physical signature of the
                            person authorised to act on behalf of the owner of
                            the copyright interest;
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            ii) &nbsp;a description of the copyrighted work that
                            you claim has been infringed;
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            iii) &nbsp;a description of where the material that
                            you claim is infringing is located on Tegal (and
                            such description must be reasonably sufficient to
                            enable the Company to find the alleged infringing
                            material, such as a url);
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            iv) &nbsp;your address, telephone number and email
                            address;
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            v) &nbsp;a written statement by you that you have a
                            good faith belief that the disputed use is not
                            authorized by the copyright owner, its agent, or the
                            law; and
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            vi) &nbsp;a statement by you, made under penalty of
                            perjury, that the above information in your notice
                            is accurate and that you are the copyright owner or
                            authorised to act on the copyright owner’s behalf.
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            b) &nbsp;Notice of claims of copyright infringement
                            should be provided to us at
                          </span>
                          <span className="s2">hello@tegalapp.com </span>
                          <span className="s1">
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            <b>15) Disclaimers </b>
                            <br />
                            a) You acknowledge and agree that neither the
                            Company nor its affiliates and third-party partners
                            are responsible for and shall not have any
                            liability, directly or indirectly, for any loss or
                            damage, including personal injury or death, as a
                            result of or alleged to be the result of;
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            i) &nbsp;any incorrect or inaccurate Content posted
                            in Tegal, whether caused by users or any of the
                            equipment or programming associated with or utilized
                            in Tegal;
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            ii) &nbsp;the timeliness, deletion or removal,
                            incorrect delivery or failure to store any Content
                            or communications;
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            iii) &nbsp;the conduct, whether online or offline,
                            of any user;
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            iv) &nbsp;any error, omission or defect in,
                            interruption, deletion, alteration, delay in
                            operation or transmission, theft or destruction of,
                            or unauthorised access to, any user or user
                            communications;
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            v) Any problems, failure or technical malfunction of
                            any telephone network or lines, computer online
                            systems, servers or providers, computer equipment,
                            software, failure of email or players on account of
                            technical problems or traffic congestion on the
                            Internet or at any website or combination thereof,
                            including injury or damage to users or to any other
                            person’s computer or device related to or resulting
                            from participating or downloading materials in
                            connection with the Internet and/or in connection
                            with Tegal.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            b) To the maximum extent allowed by applicable law,
                            the company provides Tegal on an “as is” and “as
                            available” basis and grants no warranties of any
                            kind, whether express, implied, statutory or
                            otherwise with respect to Tegal (including all
                            content contained therein), including (without
                            limitation) any implied warranties of satisfactory
                            quality, merchantability, fitness for a particular
                            purpose or non- infringement. The company does not
                            represent or warrant that Tegal will be
                            uninterrupted or error free, secure or that any
                            defects or errors in Tegal will be corrected.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            c) &nbsp;Any material downloaded or otherwise
                            obtained through the use of Tegal is accessed at
                            your own discretion and risk, and you will be solely
                            responsible for and hereby waive any and all claims
                            and causes of action with respect to any damage to
                            your device, computer system, internet access,
                            download or display device, or loss or corruption of
                            data that results or may result from the download of
                            any such material. If you do not accept this
                            limitation of liability, you are not authorised to
                            download or obtain any material through Tegal.
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            <b>16) Limitation on Liability </b>
                            <br />
                            To the fullest extent allowed by applicable law, in
                            no event will the company, its affiliates, business
                            partners, licensors or service providers be liable
                            to you or any third person for any indirect,
                            reliance, consequential, exemplary, incidental,
                            special or punitive damages, including, without
                            limitation, loss of profits, loss of goodwill,
                            damages for loss, corruption or breaches of data or
                            programs, service interruptions and procurement of
                            substitute services, even if the company has been
                            advised of the possibility of such damages.
                            Notwithstanding anything to the contrary contained
                            herein, the company’s liability to you for any cause
                            whatsoever, and regardless of the form of the
                            action, will at all times be limited to the amount
                            paid, if any, by you to the company for Tegal while
                            you have an account.
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            <b>17) Indemnity by You</b>
                            <br />
                            You agree to indemnify and hold the Company, its
                            subsidiaries, and affiliates, and its and their
                            officers, agents, partners and employees, harmless
                            from any loss, liability, claim, or demand,
                            including reasonable attorney’s fees, made by any
                            third party due to or arising out of your breach of
                            or failure to comply with this Agreement (including
                            any breach of your representations and warranties
                            contained herein), any postings or Content you post
                            in Tegal, and the violation of any law or regulation
                            by you. The Company reserves the right to assume the
                            exclusive defence and control of any matter
                            otherwise subject to indemnification by you, in
                            which event you will fully cooperate with the
                            Company in connection therewith
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            <b>18) Notice </b>
                            <br />
                            The Company may provide you with notices, including
                            those regarding changes to this Agreement, using any
                            reasonable means, which may include email or
                            postings in Tegal. Such notices may not be received
                            if you violate this Agreement by accessing Tegal in
                            an unauthorised manner. You agree that you are
                            deemed to have received any and all notices that
                            would have been delivered had you accessed Tegal in
                            an authorised manner.
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            <b>19) Entire Agreement </b>
                            <br />
                            This Agreement, with the Privacy Policy and any
                            specific guidelines or rules that are separately
                            posted for particular services or offers in the
                            Service, contains the entire agreement between you
                            and the Company regarding the use of Tegal. If any
                            provision of this Agreement is held invalid, the
                            remainder of this Agreement shall continue in full
                            force and effect. The failure of the Company to
                            exercise or enforce any right or provision of this
                            Agreement shall not constitute a waiver of such
                            right or provision. You agree that your Tegal
                            account is non-transferable and all of your rights
                            to your profile or contents within your Tegal
                            account terminate upon your death. No agency,
                            partnership, joint venture or employment is created
                            as a result of this Agreement and you may not make
                            any representations or bind the Company in any
                            manner.
                            <br />
                          </span>
                        </p>
                        <p className="p1">
                          <span className="s1">
                            <b>20) Applicable law </b>
                            <br />
                            This Agreement, its subject matter and its
                            formation, are governed by Nigerian law. You and we
                            both agree to that the courts of Nigeria will have
                            non-exclusive jurisdiction.
                            <br />
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterSection />
    </div>
  );
}

export default TermsAndCondition;
